<template>
    <div>
        <pc></pc>
        <mobile></mobile>
    </div>
</template>
<script>
import  pc          from    './components/pc'
import  mobile      from    './components/mobile'
import{
    recordIndexRequest
}from   '@/util/util'
export default{
    components:{
        pc,
        mobile
    },
    created(){
        recordIndexRequest()        //保存访问日志
    }
}
</script>
<style scoped>

@media screen and (max-width: 725px) {
    .page-pc { display: none !important;}
    .page-mobile{
        display: flex !important;
    }
}


</style>